import React, { useEffect, useState } from 'react';
import { PayPalScriptProvider } from '@paypal/react-paypal-js';
import * as Sentry from '@sentry/react';
import './services/sentry-init';
import './services/i18n';
import './App.scss';
import { MyContextProvider } from './MyContextProvider';
import Validate from './components/Validate';
import ClubSales from './components/ClubSales';
import parse from './utils/url';

// eslint-disable-next-line no-console
console.log('Version:', process.env.REACT_APP_VERSION);

// eslint-disable-next-line operator-linebreak
const { clubId, clubHash, orderId, status, backFromStripe, parentUrl, showKustom, backFromKustom, paypalOrderId } =
  parse();

function App() {
  useEffect(() => {
    if (clubId && clubHash) {
      const scope = Sentry.getCurrentScope();
      scope.setExtra('clubId', clubId);
      scope.setExtra('orderId', orderId);
    }
  }, [clubId, clubHash]);

  return (
    <Sentry.ErrorBoundary fallback={<p>An error has occurred</p>}>
      <MyContextProvider>
        <PayPalScriptProvider
          options={{
            clientId: process.env.REACT_APP_PAYPAL_CLIENT_ID,
            intent: 'capture',
            currency: 'EUR',
            'disable-funding': 'card,venmo,bancontact,blik,eps,giropay,ideal,mercadopago,mybank,p24,sepa,sofort'
          }}
        >
          <div id="golfamore-web-sales">
            <div id="modal" />
            <div id="container">
              <Switch />
            </div>
          </div>
        </PayPalScriptProvider>
      </MyContextProvider>
    </Sentry.ErrorBoundary>
  );
}

function Switch() {
  const [clubData, setClubData] = useState(null);

  const validateRequest = !clubData;
  const requestValidated = !!clubData;

  const stripeData = backFromStripe ? { orderId, status } : null;
  const kustomData = backFromKustom ? { orderId, paypalOrderId } : null;

  switch (true) {
    case validateRequest:
      return <Validate clubId={clubId} clubHash={clubHash} clubUrl={parentUrl} callback={setClubData} />;
    case requestValidated:
      return (
        <ClubSales
          clubData={{ ...clubData.settings, parentUrl }}
          stripeData={stripeData}
          showKustom={showKustom}
          kustomData={kustomData}
        />
      );
    default:
      return <p>Something went wrong</p>;
  }
}

export default App;
